import { Http } from '../../../utils/Http';
import { ApplicationSettingsRef } from '../../SystemSettings/AppSettings/ApplicationSettings';

export class AppSettingsStore {

   settings: ApplicationSettingsRef;

   initialize = async () => {
      if(this.settings?.ApplicationSettings?.length > 0) return;
      
      this.settings = await Http.get<any>({
         url: "api/Configuration/ApplicationSettings"
      });
   };

   useExternalImport = async () : Promise<boolean> => {
      await this.initialize();
      
      for(var i:number=0 ; i<this.settings?.ApplicationSettings?.length ; i++) {
        if(this.settings?.ApplicationSettings[i]?.Name === "EnableExternalJudgmentIntegration") {
          if(this.settings?.ApplicationSettings[i]?.Value === true) {
            return true;
          } else {
            return false;
          }
        }
      }
   
      return false;
    };
}

export default new AppSettingsStore();